export enum Business {
    Unknown = 0,
    Domestic = 1,
    Commercial = 2
}

export interface Truck {
    business: Business;
    computerType: string;
    deviceId: string;
    ipAddress: string;
    softwareVersion: number;
    timestamp: string;
    truckNumber: string;
    truckDesignation: string;
}
